import layout from "layouts/default"

export default {
  name: 'user-profile',
  components: {
    layout
  }
}
